module.exports = __webpack_public_path__ + "img/diap-4-1.735842b9.png";